<template>
	<nk-page commercialAccess="System" class="fiscal-modify" :policyClaims="['General_FiscalPeriod_Management']">
		<template #badges>
			<nk-badge system="accounting">
				<nk-badge-item type="system" modelValue="accounting"></nk-badge-item>
				<nk-badge-item type="system" modelValue="accounting" :title="$t('tbcp_FiscalPeriod')"></nk-badge-item>
				<nk-badge-item type="edition" :modelValue="retrieveIsEmpty() ? 'new' : 'edit'"></nk-badge-item>
			</nk-badge>
		</template>

		<div class="fiscal-info nk-card form-container">
			<div class="row nk-seprator">

				<div class="col-12 col-sm-6 col-md-4">
					<nk-col-form-group :label="$t('fiscal.f.startDate') + ':'" :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
						<nk-date :options="componentOptions.date" v-model="fiscal.startDate" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null" :tabindex="100" startup></nk-date>
					</nk-col-form-group>
				</div>

				<div class="col-12 col-sm-6 col-md-4">
					<nk-col-form-group :label="$t('fiscal.f.endDate') + ':'" :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
						<nk-date :options="componentOptions.date" v-model="fiscal.endDate" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null" :tabindex="101"></nk-date>
					</nk-col-form-group>
				</div>

				<div class="col-12 col-sm-12 col-md-4">
					<nk-col-form-group :label="$t('fiscal.f.name') + ':'" :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
						<nk-input :options="componentOptions.name" v-model="fiscal.name" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null" :tabindex="102"></nk-input>
					</nk-col-form-group>
				</div>

				<div class="col-12">
					<nk-col-form-group :label="$t('fiscal.f.description') + ':'" :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
						<nk-textarea :rows="5" :tabindex="103" v-model="fiscal.description" :disabled="[FORM_MODES.READONLY].includes(settings.mode) ? true : null"></nk-textarea>
					</nk-col-form-group>
				</div>
			</div>

			<div class="row">
				<div class="fiscal-access-title">{{ $t('fiscal.fiscalPeriod-access') }}</div>
				<div class="col-12 col-sm-12">
					<nk-company-fiscal-access-control v-if="accessDataToggler" v-model="fiscalPrivileges" ref="fiscalAccess" :options="{ entityType: 'FiscalPeriod', entityId: fiscal.id, companyId: settings.companyId }" />
				</div>
			</div>

		</div>
	</nk-page>
</template>

<script>
	import { post } from '~/plugins/nikan-api'
	import $sc from '~/plugins/shortcut.collection.js'
	import validators, { Checker } from '~/statics/validators'
	import { isEmpty } from '~/statics/validators'
	import emptyId from '~/statics/empty-id'
	import { mapActions, mapState } from 'vuex'
	import Endpoints from '@nikan/endpoints'
	import CompanyFiscalAccessControl from '~/components/fiscal-periods/fiscal-company-access-control.vue'
	import _ from 'lodash'

	export default {
		name: 'fiscal-period-modify',
		modal: {
			size: 'lg',
			stateUID: 'fiscal-period-modify',
			helpTag: 'FiscalPeriodModify'
		},
		props: {
			data: { type: Object },
			options: { type: Object }
		},
		components: {
			'nk-company-fiscal-access-control': CompanyFiscalAccessControl
		},
		watch: {
			'fiscal.endDate': {
				deep: true,
				immediate: true,
				handler(val) {
					if (val) {
						if (isEmpty(this.fiscal.id)) {
							let date = new Date(val).toLocaleDateString('fa-IR')
							this.fiscal.name = this.$t('fiscal.f.fiscal-text', { date: date })
						}
					}
				},
			}
		},
		mounted() {
			this.settings = _.merge(this.settings, this.options)

			if (this.data) {
				this.fiscal = this.data
				this.accessDataToggler = true
			}
			else if (!isEmpty(this.settings.fiscalId))
				this.getFiscal(this.settings.fiscalId).then(() => this.accessDataToggler = true)
			else
				this.accessDataToggler = true

			this.prepareWindow(this.$t(`fiscal.${isEmpty(this.fiscal.id) ? 'new-fiscal' : 'edit-fiscal'}`), [this.buttons.saveFiscal])

			this.setFormMode()
		},
		computed: {
			...mapState('appContext', {
				status: (state) => state,
			}),
		},
		data() {
			return {
				fiscalPrivileges: [],
				fiscal: {
					id: emptyId
				},
				componentOptions: {
					name: {
						required: true,
					},
					date: {
						pickerEnabled: true,
						pickerCss: 'btn btn-default',
					},
				},
				validators: {
					name: validators('required'),
					startDate: validators('required'),
					endDate: validators('required'),
				},
				settings: {},
				buttons: {
					saveFiscal: {
						title: this.$t('save'),
						shortcut: $sc.find('save'),
						isPrimary: true,
						handle: (button, page, e) => {
							e.preventDefault()

							const data = this.prepareDataForSave()

							if (this.validateInputs(data))
								this.saveFiscal(data)
						},
						icon: 'save',
						policyClaims: {
							or: ['General_FiscalPeriod_Edit', 'General_FiscalPeriod_Add'],
						},
					},
				},
				accessDataToggler: false
			}
		},
		methods: {
			...mapActions({
				appContextRefresh: 'appContext/refresh',
			}),
			prepareDataForSave() {

				const data = { fiscalPeriod: this.fiscal, id: this.fiscal.id }
				data.fiscalPeriod.companyId = this.settings.companyId
				data.fiscalPeriod.userDataAccessControls = this.fiscalPrivileges.filter(x => { return !(x.privilegeTypes.length === 0 && x.rowState == 'new') }).map((x) => {
					return {
						id: x.id,
						operationRole: { id: x.operationRoleId },
						userId: x.userId,
						entityId: x.entityId,
						entityType: x.entityType,
						privilegeType: x.privilegeTypes.join(','),
						restrict: x.restrict,
						rowState: x.rowState,
					}
				})

				return data

			},
			retrieveIsEmpty() {
				return isEmpty(this.fiscal.id)
			},
			setFormMode(fiscal = this.fiscal) {

				if (!this.options || !this.options.mode)
					this.settings.mode = this.FORM_MODES.EDITABLE
			},
			validateInputs(data) {
				let checker = new Checker((name) => this.$t(`fiscal.f.${name}`))
				let errors = checker.test(data.fiscalPeriod, this.validators)

				if (!data.fiscalPeriod.userDataAccessControls.length && this.retrieveIsEmpty())
					errors.push({ key: 'product', error: this.$t('fiscal.v.select-user-access') })

				this.validationToast(errors)
				return errors.length === 0
			},
			getFiscal(fiscalId) {
				var url = Endpoints.getUrl('fiscalPeriod.get')
				const wait = this.$wait(this.$el)

				return post(url, { id: fiscalId })
					.then((result) => {
						this.fiscal = result.data
					})
					.catch((error) => {
						error.promise.then((res) => this.reject(error))
					})
					.finally(() => {
						wait.end()
					})
			},
			saveFiscal(data) {
				return new Promise((resolve, reject) => {
					let url = isEmpty(this.fiscal.id) ? Endpoints.getUrl('fiscalPeriod.create') : Endpoints.getUrl('fiscalPeriod.update')

					var wait = this.$wait(this.$el)

					post(url, data)
						.then((response) => {
							if (this.fiscal.id === this.status.fiscalPeriod.id) {
								this.appContextRefresh({ force: true })
							}

							if (response.success) {
								resolve(response.data)
								this.resolve(response.data)
								this.$toast(this.$t('msg.create-success'), { type: 'success' })
							}
						})
						.finally(() => {
							wait.end()
						})
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.fiscal-modify {
		.fiscal-access-title {
			text-align: center;
			flex-grow: 1;
			font-size: 20px;
			font-weight: bold;
			margin-bottom: 10px;
		}
	}
</style>